import PropTypes from 'prop-types'
import React from 'react'

import {createMarkup} from './util'

import './MemberCallout.css'


const MemberCallout = ({member}) => {
  if (!member.quote) {
    return null
  }

  return (
    <div className="MemberCallout">
      <p>{member.name} had this to say about the academy:</p>
      <blockquote dangerouslySetInnerHTML={createMarkup(member.quote.quote)} />
    </div>
  )
}

MemberCallout.propTypes = {
  member: PropTypes.object
}

export default MemberCallout



// WEBPACK FOOTER //
// ./src/MemberCallout.js